import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components'
import { Header } from 'semantic-ui-react';
import * as cs from '../components/common/common-styles';
import { BackButton, ContinueButton } from '../components/common/navigation-buttons-v2';

const TightButtonWrapper = styled.div`
  margin-top: 40px;
  margin-bottom: 60px;
  display: flex;
  gap: 20px;
`;

export function ErrorPage (props) {
  const {
    clearErrors,
    backButtonClick,
    retryButtonClick,
    isPaymentError,
    paymentErrorMessage,
  } = props;

  const history = useHistory();

  const handleRetryClick = useCallback(() => {
    if (clearErrors) { clearErrors(); }
    retryButtonClick();
  }, [clearErrors, retryButtonClick, history]);

  const handleBackClick = useCallback(() => {
    if (clearErrors) { clearErrors(); }
    backButtonClick();
  }, [history, backButtonClick]);

  return (
    <cs.ViewContainer>
      <Header style={{ color: '#5c5d5d', fontSize: '50px', fontWeight: 'normal' }} size="huge">
        Something went wrong
      </Header>

      <Header style={{ color: '#5c5d5d', fontWeight: 'normal' }}>
        {isPaymentError ?
          `We were unable to process your payment; reason provided by Stripe:
            ${paymentErrorMessage ? paymentErrorMessage : "No error provided"}` :
          'There was an unexpected server error. Please try again later.'
        }
        <br />
        If the problem persists,{' '}
        <cs.Link href="mailto:str@placer.ca.gov">
          contact us.
        </cs.Link>
      </Header>

      <TightButtonWrapper>
        <ContinueButton label="Try again" onClick={handleRetryClick} />
        <BackButton
          width="200px"
          label={isPaymentError ? 'Change payment' : 'Return to main menu'}
          onClick={handleBackClick}
        />
      </TightButtonWrapper>

      {isPaymentError ?
        <img src="../../assets/payment-error-page.svg" alt="Man and X symbol statue" /> :
        <img src="../../assets/error-page.svg" alt="Multiple homes lined up" />
      }
    </cs.ViewContainer>
  );
}

export function ErrorModal(props) {
  const { open, handleClose, isPaymentError, paymentErrorMessage, paymentCallback, clearErrors } = props;
  const history = useHistory();

  const basicExitNavigation = useCallback(() => {
    history.push('/');
    handleClose();
  }, [history, handleClose]);

  return (
    <cs.WhiteModal hideBackdrop open={open} onClose={handleClose} style= {{ zIndex: 10 }}>
      <>
        <ErrorPage
          backButtonClick={isPaymentError ? handleClose : basicExitNavigation}
          retryButtonClick={isPaymentError ? paymentCallback : handleClose}
          isPaymentError={isPaymentError}
          paymentErrorMessage={paymentErrorMessage}
          paymentCallback={paymentCallback}
          clearErrors={clearErrors}
          handleClose={handleClose}
        />
      </>
    </cs.WhiteModal>
  );
}
